module.exports={
  "Source": "Kilde"
}
